/*
Author: Hoi Tak Leung
Email: hoi.leung@greedy.mx
Last Update: 25/09/2023
*/

import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation } from "swiper/modules";
import { Typography, Card, Grid, Box } from "@mui/material";

import "./ServicesCards.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";
import { useScrollReveal } from "../../../../helpers/ScrollReveal";
import { useLanguageContext } from "../../../../context/languageContext";
import { textlanguages } from "../../../../data/textOfThePage";

export default function ServicesCards() {
  const { languageSelected } = useLanguageContext();

  useScrollReveal([
    {
      selector: ".revealFromCenterCards",
      options: {
        distance: "0px",
        duration: 1000,
        easing: "ease-out",
        origin: "center",
        reset: false,
      },
    },
  ]);
  return (
    <Swiper
      effect={"coverflow"}
      navigation={true}
      loop={true}
      spaceBetween={50}
      slidesPerView={3}
      modules={[EffectCoverflow, Navigation]}
      breakpoints={{
        0: { slidesPerView: 1, spaceBetween: 20 },
        900: { slidesPerView: 3, spaceBetween: 50 },
      }}
      coverflowEffect={{
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: false,
      }}
    >
      {textlanguages[languageSelected].ourServices.tecnologyCards.map(
        (card) => (
          <SwiperSlide key={card.title}>
            <Card className="card-container">
              <Box className="card-icon-container">
                <img
                  src={card.icon}
                  className="card-icon"
                  alt="Ícono diseño y desarrollo web"
                />
              </Box>
              <Typography variant="h5" className="card-title">
                {card.title}
              </Typography>
              <Typography variant="h6" className="card-description">
                {card.description}
              </Typography>
              <Grid container>
                {card.tecnologies.map((tecnology) => (
                  <Grid item xs={3} key={tecnology.name}>
                    <img
                      src={tecnology.icon}
                      className="technology-icon"
                      alt={`${tecnology.name} Logo`}
                    />
                  </Grid>
                ))}
              </Grid>
            </Card>
          </SwiperSlide>
        )
      )}
    </Swiper>
  );
}
